import React from "react";
import * as echarts from "echarts";
import {useEffect} from "react";

const ChartTotalComodity = ({
  dataChart,
  kodeTrayek = "",
  yearTotalCom = "",
}) => {
  useEffect(() => {
    let chartDom = document.getElementById("charttotalcomodity");
    let myChart = echarts.init(chartDom);
    let option;

    if (
      dataChart.data &&
      dataChart.data.jenis_barang_chart &&
      dataChart.data.jenis_barang_chart.length > 0
    ) {
      let xAxisData = [],
        seriesData = [],
        totComodity = [];
      const dataCharts = dataChart.data.jenis_barang_chart.map((elem) => {
        return {
          ...elem,
          total: elem.jenis_barang.reduce((prev, curr) => {
            return prev + curr.total_comodity;
          }, 0),
        };
      });
      // console.log('dataCharts ', dataCharts)
      const kodeTrk = kodeTrayek && kodeTrayek.value ? kodeTrayek.value : "";
      const year = yearTotalCom && yearTotalCom.value ? yearTotalCom.value : "";

      let maxNumber = dataCharts.map((item) => item.jenis_barang.length)[0];

      dataCharts
        .map((item) => item.jenis_barang.length)
        .map((val, i) => {
          if (val > maxNumber) {
            maxNumber = val;
          }
        });

      if (kodeTrk !== "") {
        if (year !== "") {
          totComodity = dataCharts
            .filter((x) => x.trayek === kodeTrk && x.tahun_trayek === year)
            .map((x) => x.total);
          xAxisData = dataCharts
            .filter((x) => x.trayek === kodeTrk && x.tahun_trayek === year)
            .map((entry) => entry.trayek);

          seriesData = dataCharts
            .filter((item) => item.jenis_barang.length === maxNumber)[0]
            .jenis_barang.map((item) => ({
              name: item.jenis_barang_name,
              data: dataCharts
                .filter((x) => x.trayek === kodeTrk && x.tahun_trayek === year)
                .map(
                  (entry) =>
                    entry.jenis_barang.find(
                      (jenis_barang) =>
                        jenis_barang.jenis_barang_name ===
                        item.jenis_barang_name
                    )?.total_comodity || 0
                ),
            }));
        } else {
          totComodity = dataCharts
            .filter((x) => x.trayek === kodeTrk)
            .map((x) => x.total);
          xAxisData = dataCharts
            .filter((x) => x.trayek === kodeTrk)
            .map((entry) => entry.trayek);

          seriesData = dataCharts
            .filter((item) => item.jenis_barang.length === maxNumber)[0]
            .jenis_barang.map((item) => ({
              name: item.jenis_barang_name,
              data: dataCharts
                .filter((x) => x.trayek === kodeTrk)
                .map(
                  (entry) =>
                    entry.jenis_barang.find(
                      (jenis_barang) =>
                        jenis_barang.jenis_barang_name ===
                        item.jenis_barang_name
                    )?.total_comodity || 0
                ),
            }));
        }
      } else {
        if (year !== "") {
          totComodity = dataCharts
            .filter((x) => x.tahun_trayek === year)
            .map((x) => x.total);
          xAxisData = dataCharts
            .filter((x) => x.tahun_trayek === year)
            .map((entry) => entry.trayek);
          seriesData = dataCharts
            .filter((item) => item.jenis_barang.length === maxNumber)[0]
            .jenis_barang.map((item) => ({
              name: item.jenis_barang_name,
              data: dataCharts
                .filter((x) => x.tahun_trayek === year)
                .map(
                  (entry) =>
                    entry.jenis_barang.find(
                      (jenis_barang) =>
                        jenis_barang.jenis_barang_name ===
                        item.jenis_barang_name
                    )?.total_comodity || 0
                ),
            }));
        } else {
          totComodity = dataCharts.map((x) => x.total);
          xAxisData = dataCharts.map((entry) => entry.trayek);

          seriesData = dataCharts
            .filter((item) => item.jenis_barang.length === maxNumber)[0]
            .jenis_barang.map((item) => ({
              name: item.jenis_barang_name,
              data: dataCharts.map(
                (entry) =>
                  entry.jenis_barang.find(
                    (jenis_barang) =>
                      jenis_barang.jenis_barang_name === item.jenis_barang_name
                  )?.total_comodity || 0
              ),
            }));
        }
      }

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
            axisLabel: {interval: 0, rotate: 90},
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },

        series: [
          ...seriesData.map((seriesItem) => ({
            name: seriesItem.name,
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: seriesItem.data,
          })),
          {
            name: "Total Komoditas",
            type: "line",
            stack: "Ad",
            label: {
              show: true,
              position: "top",
            },
            emphasis: {
              focus: "series",
            },
            data: totComodity,
          },
        ],
      };

      option && myChart.setOption(option);
    }
  }, [kodeTrayek, yearTotalCom]);

  return (
    <div
      id="charttotalcomodity"
      style={{width: "100%", height: "410px", padding: "10px"}}
    />
  );
};

export default ChartTotalComodity;
